import { useRef, useState, useEffect } from "react";
import { FaPause, FaPlay } from "react-icons/fa";
import "./index.css";

export const AudioPlayer = ({ src, autoPlayDelay = null }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    let autoplayTimeout 
    if(autoPlayDelay) {
      autoplayTimeout = setTimeout(() => {
        audioRef.current.play()
        setIsPlaying(true)
      }, autoPlayDelay * 1000)
    }
    return () => clearTimeout(autoplayTimeout)
  }, [autoPlayDelay])

  const durationChangeHandler = (event) => {
    setDuration(Math.floor(event.target.duration));
  };

  const timeUpdateHandler = (event) => {
    setCurrentTime(Math.floor(event.target.currentTime));
  };

  const audioEndedHandler = () => {
    audioRef.current.currentTime = 0;
    setIsPlaying(false);
  };

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
  };

  const handleSliderChange = (event) => {
    audioRef.current.currentTime = event.target.value;
    setCurrentTime(event.target.value);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(remainingSeconds).padStart(2, "0");
    return `${formattedMinutes}:${formattedSeconds}`;
  };

  return (
    <div className="flex items-center justify-between gap-4 rounded-lg bg-bistre py-[10px] px-4 text-white">
      <audio
        ref={audioRef}
        autoPlay={false}
        onDurationChange={durationChangeHandler}
        onTimeUpdate={timeUpdateHandler}
        onEnded={audioEndedHandler}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
      >
        <source src={src} type="audio/mp3" />
      </audio>
      <button onClick={togglePlay}>
        {isPlaying ? <FaPause /> : <FaPlay />}
      </button>
      <input
        className="audio-slider"
        type="range"
        min={0}
        max={duration}
        step="1"
        value={currentTime}
        onChange={handleSliderChange}
      />
      <p className="text-base font-medium">{formatTime(currentTime)}</p>
    </div>
  );
};
